import { z } from "zod";

/** 统一错误响应体 —— 前端只认这一种失败形状 */
export const errorResponseSchema = z.object({
  code: z.string(),
  message: z.string(),
  traceId: z.string(),
  details: z.unknown().optional(),
});
export type ErrorResponse = z.infer<typeof errorResponseSchema>;

/** 游标分页：建材类目动辄上万 SKU，不用 offset */
export const pageQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});
export type PageQuery = z.infer<typeof pageQuerySchema>;

export function pagedSchema<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
  });
}

export const idParamSchema = z.object({ id: z.string().min(1) });
